module.exports = __webpack_public_path__ + "img/img-a70b04.png";